import Client from "./client";

// The project's FAQ - the self-help half of support. The member-facing list
// includes drafts; the published subset reaches visitors with the public intake
// page itself (see GetPublicSupportProject), not from here.

export const GetSupportFaqs = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/support-faqs`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.supportFaqs);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateSupportFaq = ({projectId, question, answer, published, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/support-faqs`, {question, answer, published}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.supportFaq);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

export const UpdateSupportFaq = ({faqId, question, answer, published, accessToken}) => {
    const data = {};
    if (question !== undefined) data.question = question;
    if (answer !== undefined) data.answer = answer;
    if (published !== undefined) data.published = published;

    return new Promise((resolve, reject) => {
        Client.put(`/api/support-faqs/${faqId}`, data, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.supportFaq);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteSupportFaq = ({faqId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/support-faqs/${faqId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// The whole list in its new order - the API rejects anything that isn't exactly a
// permutation of the project's current entries.
export const ReorderSupportFaqs = ({projectId, faqIds, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/projects/${projectId}/support-faqs/reorder`, {faqIds}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.supportFaqs);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
